import PropTypes from 'prop-types';
import RadioElement from '../../RadioElement';
import { CurrentDataProvider } from '../../../currentDataCtx';

function RadioCellEditor(props) {
  const { value, onValueChange, data, context, componentProps } = props;
  // eslint-disable-next-line no-unused-vars
  const { valueType, ...restComponentProps } = componentProps || {};
  return (
    <CurrentDataProvider value={data}>
      <RadioElement
        className="table-radio-editor"
        suppressFormControl={true}
        value={value}
        onChange={onValueChange}
        componentProps={{
          size: context.tableSize,
          ...restComponentProps,
        }}
      />
    </CurrentDataProvider>
  );
}

RadioCellEditor.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    }),
  ]),
  onValueChange: PropTypes.func,
  data: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  context: PropTypes.shape({
    tableSize: PropTypes.oneOf(['default', 'small']),
  }),
  componentProps: PropTypes.shape({}),
};

export default RadioCellEditor;
